import React from "react";
import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import DefaultLayout from "../layouts/index";
import Login from "../pages/auth/Login";
import NewPassword from "../pages/auth/NewPassword";
import PasswordSuccessful from "../pages/auth/PasswordSuccessful";
import ResetPassword from "../pages/auth/ResetPassword";
import Dashboard from "../pages/dashboard/Dashboard";
import RoleAndAccess from "../pages/accounts/RoleAndAccess";
import StaffAccounts from "../pages/accounts/StaffAccounts";
import CreateEditStaffAccount from "../pages/accounts/CreateEditStaffAccount";
import CreateEditTechnicianAccount from "../pages/technicians/CreateEditTechnicianAccount";
import Technicians from "../pages/technicians/Technicians";
import Companies from "../pages/companies/Companies";
import CreateCompany from "../pages/companies/createEditcompany/companyinformation/CreateCompany";
import CreateEditCompany from "../pages/companies/createEditcompany/CreateEditCompany";
import EditCompanyModal from "../pages/companies/modal/EditCompanyModal";
import Product from "../pages/product/Product";
import CreateEditProduct from "../pages/product/CreateEditProduct";
import SuccessReset from "../pages/technicians/SuccessReset";
import AddNewOutlet from "../pages/companies/modal/AddEditOutlet";
import ProductCategory from "../pages/productCategory/Category";
import CreateEditCategory from "../pages/productCategory/CreateEditCategory";
import ServiceRequest from "../pages/serviceRequest/ServiceRequest";
import ViewService from "../pages/serviceRequest/ViewService";
import CreateEditRequest from "../pages/serviceRequest/CreateEditRequest";
import Scheduling from "../pages/serviceRequest/schedule/Scheduling";
import AddNewEquipment from "../pages/companies/modal/AddEditEquipment";
import AddEditStaff from "../pages/companies/modal/AddEditStaff";
import ViewScheduling from "../pages/serviceRequest/schedule/ViewScheduling";
import ServiceReport from "../pages/serviceRequest/servicereport/ServiceReport";
import ViewServiceReport from "../pages/serviceRequest/servicereport/ViewServiceReport";
import Recurring from "../pages/recurring/Recurring";
import CreateEditRecurring from "../pages/recurring/CreateEditRecurring";
import ContractPreview from "../pages/recurring/ContractPreview";
import AddEditTransfer from "../pages/companies/modal/AddEditTransfer";
import CreateEditRecurringService from "../pages/serviceRequest/CreateEditRecurring";
import SalesList from "../pages/sales/Sales";
import ContractPreviewModal from "../pages/recurring/ContractPreviewModal";
import SchedulingModal from "../pages/serviceRequest/schedule/SchedulingModal";
import MasterSetting from "../pages/mastersetting/MasterSetting";
import Profile from "../pages/profile/Profile";
import ProductInterest from "../pages/productInterest/ProductInterest";
import Notification from "../pages/notification/Notification";
import ActivityLog from "../pages/activitylog/ActivityLog";
import Earning from "../pages/technicians/technicianEarning/Earning";
import SalesReports from "../pages/reports/SalesReports";
import ServiceRequestReports from "../pages/reports/ServiceReport";
import CompaniesReports from "../pages/reports/CompaniesReports";
import OutstandingReports from "../pages/reports/OutstandingReports";
import PrivacyPolicy from "../pages/legal/PrivacyPolicy";
import TermsAndConditions from "../pages/legal/TermsAndConditions";

const AppRoutes = () => {
  return (
    <>
      <ToastContainer
        position="bottom-right"
        theme="colored"
        style={{ zIndex: 10000 }}
      />
      <Routes>
        {/* Auth */}
        <Route exact path="/login" status={401} element={<Login />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/new-password/:email/:token" element={<NewPassword />} />
        <Route path="/password-successful" element={<PasswordSuccessful />} />
        {/* Legal pages */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        {/* DefaultLayout */}
        <Route path="/" element={<DefaultLayout />}>
          {/* Dashboard */}
          <Route index exact element={<Dashboard />} />
          <Route path="/profile" element={<Profile />} />
          {/* Accounts */}
          <Route path="/role-access" element={<RoleAndAccess />} />
          <Route path="/staff-accounts" element={<StaffAccounts />} />
          <Route
            path="/create-edit-staff-account"
            element={<CreateEditStaffAccount />}
          />
          {/* Technicians */}
          <Route path="/technicians" element={<Technicians />} />
          <Route path="/reset" element={<SuccessReset />} />
          <Route
            path="/create-edit-technician-account"
            element={<CreateEditTechnicianAccount />}
          />
          <Route path="/earnings" element={<Earning />} />
          {/* Service request */}
          <Route path="/services" element={<ServiceRequest />} />
          <Route path="/view-service" element={<ViewService />} />
          <Route path="/create-edit-service" element={<CreateEditRequest />} />
          <Route
            path="/create-edit-recurring-service"
            element={<CreateEditRecurringService />}
          />
          {/* Service scheduling */}
          <Route path="/scheduling" element={<Scheduling />} />
          <Route path="/view-schedule" element={<ViewScheduling />} />
          <Route path="/modal" element={<SchedulingModal />} />
          {/* Service Report */}
          <Route path="/service-report" element={<ServiceReport />} />
          <Route path="/view-report" element={<ViewServiceReport />} />
          {/* Comopany Outlet */}
          <Route path="/companies" element={<Companies />} />
          <Route path="/create-edit-company" element={<CreateCompany />} />
          <Route path="/company-information" element={<CreateEditCompany />} />
          <Route path="/edit" element={<EditCompanyModal />} />
          <Route path="/create-edit-outlet" element={<AddNewOutlet />} />
          <Route path="/create-edit-equipment" element={<AddNewEquipment />} />
          <Route path="/create-edit-staff" element={<AddEditStaff />} />
          <Route path="/create-edit-transfer" element={<AddEditTransfer />} />
          {/* Product */}
          <Route path="/products" element={<Product />} />
          <Route path="/create-edit-product" element={<CreateEditProduct />} />
          <Route path="/product-categories" element={<ProductCategory />} />
          <Route
            path="/create-edit-categories"
            element={<CreateEditCategory />}
          />
          {/* Recurring Contract */}
          <Route path="/maintenance-contract" element={<Recurring />} />
          <Route path="/contract-preview" element={<ContractPreview />} />
          <Route
            path="/create-edit-recurring"
            element={<CreateEditRecurring />}
          />
          <Route
            path="/contract-preview-modal"
            element={<ContractPreviewModal />}
          />
          {/* sales */}
          <Route path="/sales" element={<SalesList />} />

          {/* master setting */}
          <Route path="/general-settings" element={<MasterSetting />} />
          <Route path="/billing-settings" element={<MasterSetting />} />
          <Route path="/faq-settings" element={<MasterSetting />} />
          <Route path="/banner-settings" element={<MasterSetting />} />

          {/* ProductInterest */}
          <Route path="/product-interest" element={<ProductInterest />} />

          {/* notification */}
          <Route path="/notification" element={<Notification />} />
          {/* Activity Log */}
          <Route path="/activity-log" element={<ActivityLog />} />

          {/* reports */}
          <Route path="/sales-report" element={<SalesReports />} />
          <Route
            path="/reports-service-report"
            element={<ServiceRequestReports />}
          />
          <Route
            path="/company-service-report"
            element={<CompaniesReports />}
          />
          <Route path="/outstanding-report" element={<OutstandingReports />} />
        </Route>
      </Routes>
    </>
  );
};

export default AppRoutes;
